export const ourProducts = [
    {
      title: 'Supply Chain Visibility and Optimization Software',
      subtitle:
        'Gain complete visibility and optimize your supply chain with our software. Track every stage of your supply chain in real-time, identify bottlenecks, and enhance overall efficiency.',
      img: 'url(/industries/logistics/supply-chain-visibility-and-optimization-software.jpg)',
      content:
        'Track every stage of your supply chain in real-time, identify bottlenecks, and enhance overall efficiency with our Supply Chain Visibility and Optimization Software.',
      link: '/industries/logistics/products/supply-chain-visibility-and-optimization-software',
    },
    {
      title: 'Last-Mile Delivery Routing Algorithms',
      subtitle:
        'Optimize your last-mile delivery operations with our advanced routing algorithms. Reduce delivery times, lower costs, and enhance customer satisfaction with efficient and dynamic route planning.',
      img: 'url(/industries/logistics/last-mile-delivery-routing-algorithms.jpg)',
      content:
        'Reduce delivery times, lower costs, and enhance customer satisfaction with efficient and dynamic route planning using our Last-Mile Delivery Routing Algorithms.',
      link: '/industries/logistics/products/last-mile-delivery-routing-algorithms',
    },
    {
      title: 'Warehouse Management Systems',
      subtitle:
        'Streamline your warehouse operations with our Warehouse Management Systems. From inventory tracking to order fulfillment, our software ensures precision and efficiency in warehouse processes.',
      img: 'url(/industries/logistics/warehouse-management-systems.jpg)',
      content:
        'From inventory tracking to order fulfillment, our software ensures precision and efficiency in warehouse processes with our Warehouse Management Systems.',
      link: '/industries/logistics/products/warehouse-management-systems',
    },
    {
      title: 'Transportation Management Systems (TMS)',
      subtitle:
        'Revolutionize your transportation processes with our TMS. Optimize routes, manage shipments, and enhance collaboration with carriers for a seamless transportation network.',
      img: 'url(/industries/logistics/transportation-management-systems.jpg)',
      content:
        'Optimize routes, manage shipments, and enhance collaboration with carriers for a seamless transportation network with our Transportation Management Systems (TMS).',
      link: '/industries/logistics/products/transportation-management-systems',
    },
    {
      title: 'Freight Brokerage and Digital Freight Platforms',
      subtitle:
        'Facilitate efficient freight brokerage with our digital platforms. Connect shippers with carriers seamlessly, automate processes, and optimize freight management for cost-effective operations.',
      img: 'url(/industries/logistics/freight-brokerage-and-digital-freight-platforms.avif)',
      content:
        'Connect shippers with carriers seamlessly, automate processes, and optimize freight management for cost-effective operations with our Freight Brokerage and Digital Freight Platforms.',
      link: '/industries/logistics/products/freight-brokerage-and-digital-freight-platforms',
    },
    {
      title: 'Inventory Forecasting and Demand Planning Software',
      subtitle:
        'Anticipate market demands and optimize inventory levels with our forecasting and demand planning software. Minimize stockouts, reduce excess inventory, and enhance overall supply chain performance.',
      img: 'url(/industries/logistics/inventory-forecasting-and-demand-planning-software.jpg)',
      content:
        'Minimize stockouts, reduce excess inventory, and enhance overall supply chain performance with our Inventory Forecasting and Demand Planning Software.',
      link: '/industries/logistics/products/inventory-forecasting-and-demand-planning-software',
    },
    {
      title: 'Cold Chain Monitoring and Management Systems',
      subtitle:
        'Ensure the integrity of temperature-sensitive goods with our Cold Chain Management Systems. Monitor and manage the cold chain effectively to guarantee the quality of your products.',
      img: 'url(/industries/logistics/cold-chain-monitoring-and-management-systems.avif)',
      content:
        'Monitor and manage the cold chain effectively to guarantee the quality of your products with our Cold Chain Monitoring and Management Systems.',
      link: '/industries/logistics/products/cold-chain-monitoring-and-management-systems',
    },
    {
      title: 'Route Optimization and Fleet Management Software',
      subtitle:
        'Optimize routes and manage your fleet efficiently with our software. Enhance delivery speed, reduce fuel costs, and improve overall fleet performance for a competitive edge.',
      img: 'url(/industries/logistics/route-optimization-and-fleet-management-software.jpg)',
      content:
        'Enhance delivery speed, reduce fuel costs, and improve overall fleet performance for a competitive edge with our Route Optimization and Fleet Management Software.',
      link: '/industries/logistics/products/route-optimization-and-fleet-management-software',
    },
    {
      title: 'Reverse Logistics and Returns Management Solutions',
      subtitle:
        'Streamline reverse logistics and returns processes with our solutions. Efficiently handle product returns, minimize costs, and enhance customer satisfaction with hassle-free return management.',
      img: 'url(/industries/logistics/reverse-logistics-and-returns-management-solutions.jpg)',
      content:
        'Efficiently handle product returns, minimize costs, and enhance customer satisfaction with hassle-free return management using our Reverse Logistics and Returns Management Solutions.',
      link: '/industries/logistics/products/reverse-logistics-and-returns-management-solutions',
    },
    {
      title: 'Collaborative Logistics and Freight Management Platforms',
      subtitle:
        'Foster collaboration in your logistics network with our collaborative platforms. Connect stakeholders, improve communication, and optimize freight management for enhanced efficiency.',
      img: 'url(/industries/logistics/collaborative-logistics-and-freight-management-platforms.jpg)',
      content:
        'Foster collaboration in your logistics network with our Collaborative Logistics and Freight Management Platforms. Connect stakeholders, improve communication, and optimize freight management for enhanced efficiency.',
      link: '/industries/logistics/products/collaborative-logistics-and-freight-management-platforms',
    },
    {
      title: 'Customs Compliance and Trade Facilitation Software',
      subtitle:
        'Ensure seamless international trade with our software. Stay compliant with customs regulations, expedite clearance processes, and facilitate smooth cross-border transactions.',
      img: 'url(/industries/logistics/customs-compliance-and-trade-facilitation-software.jpg)',
      content:
        'Stay compliant with customs regulations, expedite clearance processes, and facilitate smooth cross-border transactions with our Customs Compliance and Trade Facilitation Software.',
      link: '/industries/logistics/products/customs-compliance-and-trade-facilitation-software',
    },
    {
      title: 'Supplier Collaboration and Vendor Management Systems',
      subtitle:
        'Strengthen relationships with suppliers using our collaboration and management systems. Enhance communication, streamline procurement, and optimize vendor relationships for mutual success.',
      img: 'url(/industries/logistics/supplier-collaboration-and-vendor-management-systems.jpg)',
      content:
        'Enhance communication, streamline procurement, and optimize vendor relationships for mutual success with our Supplier Collaboration and Vendor Management Systems.',
      link: '/industries/logistics/products/supplier-collaboration-and-vendor-management-systems',
    },
    {
      title: 'Real-time Shipment Tracking and Visibility Solutions',
      subtitle:
        'Provide real-time visibility to your shipments with our tracking solutions. Keep customers informed, reduce uncertainties, and ensure a transparent and reliable supply chain.',
      img: 'url(/industries/logistics/real-time-shipment-tracking-and-visibility-solutions.jpg)',
      content:
        'Keep customers informed, reduce uncertainties, and ensure a transparent and reliable supply chain with our Real-time Shipment Tracking and Visibility Solutions.',
      link: '/industries/logistics/products/real-time-shipment-tracking-and-visibility-solutions',
    },
    {
      title: 'Autonomous Vehicle Fleet Management Software',
      subtitle:
        'Embrace the future of logistics with our autonomous vehicle fleet management software. Efficiently manage and optimize your autonomous vehicle fleet for reliable and efficient operations.',
      img: 'url(/industries/logistics/autonomous-vehicle-fleet-management-software.jpg)',
      content:
        'Efficiently manage and optimize your autonomous vehicle fleet for reliable and efficient operations with our Autonomous Vehicle Fleet Management Software.',
      link: '/industries/logistics/products/autonomous-vehicle-fleet-management-software',
    },
    {
      title: 'Blockchain for Transparent and Secure Supply Chains',
      subtitle:
        'Ensure transparency and security in your supply chain with blockchain technology. Establish trust, trace products seamlessly, and enhance overall supply chain integrity.',
      img: 'url(/industries/logistics/blockchain-for-transparent-and-secure-supply-chains.jpg)',
      content:
        'Establish trust, trace products seamlessly, and enhance overall supply chain integrity with our Blockchain for Transparent and Secure Supply Chains.',
      link: '/industries/logistics/products/blockchain-for-transparent-and-secure-supply-chains',
    },
    {
      title: 'Procurement and Purchase Order Management Software',
      subtitle:
        'Streamline procurement processes with our software. Manage purchase orders, automate workflows, and optimize procurement activities for cost-effective and efficient operations.',
      img: 'url(/industries/logistics/procurement-and-purchase-order-management-software.jpg)',
      content:
        'Manage purchase orders, automate workflows, and optimize procurement activities for cost-effective and efficient operations with our Procurement and Purchase Order Management Software.',
      link: '/industries/logistics/products/procurement-and-purchase-order-management-software',
    },
    {
      title: 'Cross-Border Trade Compliance and Documentation Tools',
      subtitle: 
        'Simplify cross-border trade with our compliance and documentation tools. Stay compliant with international regulations, streamline documentation, and facilitate smooth cross-border transactions.',
      img: 'url(/industries/logistics/cross-border-trade-compliance-and-documentation-tools.jpg)',
      content:
        'Stay compliant with international regulations, streamline documentation, and facilitate smooth cross-border transactions with our Cross-Border Trade Compliance and Documentation Tools.',
      link: '/industries/logistics/products/cross-border-trade-compliance-and-documentation-tools',
    },
    {
      title: 'Automated Palletization and Sorting Systems',
      subtitle:
        'Enhance warehouse efficiency with our automated palletization and sorting systems. Optimize storage, minimize errors, and improve overall warehouse productivity.',
      img: 'url(/industries/logistics/automated-palletization-and-sorting-systems.jpg)',
      content:
        'Optimize storage, minimize errors, and improve overall warehouse productivity with our Automated Palletization and Sorting Systems.',
      link: '/industries/logistics/products/automated-palletization-and-sorting-systems',
    },
    {
      title: 'Digital Twin Technology for Supply Chain Simulation',
      subtitle:
        'Visualize and simulate your supply chain with digital twin technology. Optimize logistics, identify potential issues, and enhance overall supply chain resilience through virtual modeling.',
      img: 'url(/industries/logistics/digital-twin-technology-for-supply-chain-simulation.jpg)',
      content:
        'Optimize logistics, identify potential issues, and enhance overall supply chain resilience through virtual modeling with our Digital Twin Technology for Supply Chain Simulation.',
      link: '/industries/logistics/products/digital-twin-technology-for-supply-chain-simulation',
    },
    {
      title: 'Predictive Analytics for Supply Chain Risk Management',
      subtitle:
        'Mitigate supply chain risks with our predictive analytics. Identify potential disruptions, proactively manage risks, and ensure continuity in your supply chain operations.',
      img: 'url(/industries/logistics/predictive-analytics-for-supply-chain-risk-management.avif)',
      content:
        'Identify potential disruptions, proactively manage risks, and ensure continuity in your supply chain operations with our Predictive Analytics for Supply Chain Risk Management.',
      link: '/industries/logistics/products/predictive-analytics-for-supply-chain-risk-management',
    },
  ]

